<template>
  <div>
  <KV/>
    <section id="search">
        <transition name="fade">
            <Loading v-if="isLoading == true" />
        </transition>
      <div class="topSearch">
        <div class="container">
            <img src="../assets/bow.png" alt="" class="bow">
        <img src="../assets/icon-plus.svg" alt="" class="searchTresure">
        <h2>你擁有的【立即抽獎】次數是 <span v-text="amount"></span> 次</h2>
        <a class="btn" id="goLottery">確定</a>
        </div>
      </div>
      <div class="container">
          <div class="toggleText" :class="{close: active}" @click="searchToggle">查看使用紀錄<svg xmlns="http://www.w3.org/2000/svg" class="arrow" :class="{rotate: active}" width="18" height="10" viewBox="0 0 18 10" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9944 9.23733C16.4491 9.86098 15.5015 9.9245 14.8779 9.3792L9.00304 4.2425L3.12821 9.3792C2.50456 9.9245 1.55694 9.86098 1.01164 9.23732C0.466347 8.61367 0.529867 7.66605 1.15352 7.12075L9.00304 0.257461L16.8526 7.12076C17.4762 7.66605 17.5397 8.61367 16.9944 9.23733Z" fill="white"/>
          </svg></div>
      </div>
      <transition
          name="slide"
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @leave="leave"
          @after-leave="afterLeave"
        >
      <div class="bottomSearch" v-if="active === false">
        <div class="container">
          <div class="searchList">
            <h3>【立即抽獎】活動紀錄</h3>
            <div id="css_table">
              <div class="css_tr Table-title">
                  <div class="css_td">日期</div>
                  <div class="css_td">項目</div>
                  <div class="css_td">說明</div>
              </div>
              <div class="css_tr" v-for="item in actData" :key="item.id">
                  <div class="css_td">{{item.createTime}}</div>
                  <div class="css_td">{{item.title}}</div>
                  <div class="css_td havePrize" v-if="item.whetherWinLottery"><a @click="alertPrice(item)">{{item.status}}</a></div>
                  <div class="css_td" v-else>{{item.status}}</div>
              </div>
            </div>
          </div>
          <div class="searchList">
            <h3>大獎及其他獎項抽獎資格</h3>
            <div id="css_table">
              <div class="css_tr Table-title">
                  <div class="css_td">日期</div>
                  <div class="css_td">項目</div>
                  <div class="css_td">說明</div>
              </div>
              <div class="css_tr" v-for="item in qualifyData" :key="item.id">
                  <div class="css_td">{{item.createTime}}</div>
                  <div class="css_td">{{item.action}}</div>
                  <div class="css_td">{{item.description}}</div>
              </div>  
            </div>
          </div>
<!--          <p class="center">(此部分為次月或活動結束後進行電腦抽獎，得獎結果請見得獎名單頁)</p>-->
        </div>
      </div>
      </transition>
    </section>
  </div>
 
</template>
<script setup>
import KV from "@/components/kv.vue";
import Loading from "@/components/loading.vue";
import Swal from "sweetalert2/dist/sweetalert2";
import { ref, onBeforeMount } from "vue";
import { getApi } from "@/utils/callApi";
import apiConfig from "@/utils/apiConfig";
import { useRouter } from "vue-router";
import debounce from "lodash.debounce";

const active = ref(false);
const amount = ref("0");
const actData = ref({});
const qualifyData = ref({});
const isLoading = ref(true);
const router = useRouter();

const init = () => {
    const jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
    getApi(apiConfig.activityDomain + apiConfig.showLotteryRecord, jwtInfo.token)
        .then((response) => {
            isLoading.value = false;
            amount.value = response.data.data.lotteryAmount;
            actData.value = response.data.data.actList;
            qualifyData.value = response.data.data.qualifyList;
            if (response.data.code === 200) {
                document.querySelector("#goLottery").addEventListener("click", () => {
                    router.push("/FY24_luckydraw/lottery");
                });
            } else if (response.data.code === 400) {
                document.querySelector("#goLottery").addEventListener("click", () => {
                    Swal.fire("您的抽獎次數為 0");
                });
            }
        });
};

const searchToggle = () => {
    active.value = !active.value;
};

const beforeEnter = (element) => {
    requestAnimationFrame(() => {
        if (!element.style.height) {
            element.style.height = "0px";
        }
        element.style.display = null;
    });
};

const enter = (element) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            element.style.height = `${element.scrollHeight}px`;
        });
    });
};

const afterEnter = (element) => {
    element.style.height = null;
};

const beforeLeave = (element) => {
    requestAnimationFrame(() => {
        if (!element.style.height) {
            element.style.height = `${element.offsetHeight}px`;
        }
    });
};

const leave = (element) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            element.style.height = "0px";
        });
    });
};

const afterLeave = (element) => {
    element.style.height = null;
};

const alertPrice = debounce((item) => {
    let prizeString = "";
    if (item.prizeLink) {
        prizeString += `<a href="${item.prizeLink}" target="_blank">${item.prizeLink}</a>`;
    }
    if (item.prizeCode) {
        prizeString += `<p>開啟密碼：${item.prizeCode}</p>`;
    }
    Swal.fire({
        title: item.prizeName,
        html: `<p class="prizeIntro">${item.prizeInstruction}</p>${prizeString}<p>${item.prizeDescription}</p>`,
        imageUrl: item.prizeImageLink,
        confirmButtonText: "確定",
        customClass: {
            container: "lotterySuccess",
        },
    });
}, 500);

onBeforeMount(() => {
    init();
});
</script>
<style lang="scss">
#search{
    background: #FFECE3;
  padding-bottom:5%;
  .topSearch{
    padding: 50px 20px;
    .container{
      background-color:$white;
      border-radius:20px;
      padding:80px 30px 30px ;
      background-repeat: no-repeat;
      background-position: center top;
      text-align: center;
      position:relative;
      border:6px solid #E0713A;
      box-sizing: border-box;
      margin-bottom: 30px;
      .bow{
        position:absolute;
        top:-40px;
      }
    }
    &+.container{
      @media screen and (max-width:$mobile-small) {
        padding:0 20px;
      }
    }

  .searchTresure{display:inline-block;width:112px;}
  h2{color:$blue-700;font-size:32px;margin:20px auto;
      @media screen and (max-width: $mobile-small) {
          font-size:25px;
      }
  span{color:$pink-800}
  
  }
  
  }
  .toggleText{
    margin-top:10px;
    color:$white;
    background:$blue-700;
    border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    text-align: center;
    padding:20px 0;
    font-size:20px;
    cursor: pointer;
      font-weight:700;
      &.close{
          border-radius:20px;
      }
    .arrow{
      position: relative;
      top:-5px;
      margin-left:10px;
      &.rotate {
          transform: rotateX(-180deg);
      }
    }

  }
  .bottomSearch{
    padding:0 20px;
    .container{
      background-color: $white;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
      padding-bottom:30px;
      @media screen and (max-width: $mobile-small) {
        padding:0 0 30px 0;
      }
    }
   
    h3{
      color:$blue-700;
      text-align: center;
      font-weight:bolder;
      padding:20px 0;
        font-size: 20px;
    }
    .searchList{
      width:100%;
      margin: 0 auto;
      padding:40px 30px;
        box-sizing: border-box;
        font-size: 16px;
      @media screen and (max-width: $mobile-large) {
        width:100%;
        font-size:14px;
      }
        @media screen and (max-width: $mobile-small) {
            padding:20px 10px;
        }
      &:last-of-type{border:0;padding-top:0}
      .Table-title{
          color:$black;
          font-size:16px;
        font-weight:bold;
          line-height:40px;
            .css_td{
              border-bottom:1px solid #e8e8e8;
              margin-bottom:10px;
               @media screen and (max-width: $mobile-small) {
                line-height:23px;
              }
            }
      }
    }
   
  }
  .slide-leave-active,
  .slide-enter-active {
    overflow: hidden;
    transition: height 0.5s linear;
  }
  .havePrize{
    cursor: pointer;
      a{
          text-decoration: underline;
      }
  }
  #css_table {
    display:table;
    width: 100%;
    box-sizing: border-box;
  }
  .css_tr {
    display: table-row;
    &:nth-child(even){
      background:#F2F7FC;
    }
  }
  .css_td {
    display: table-cell;
    text-align: center;
    line-height:30px;
    padding:5px 1px;

    @media screen and (max-width: $mobile-small) {
      line-height:0.9rem;
      font-size:0.65rem;
      padding:5px 2px;
      &:first-of-type{
        width: 25%;
      }
    }
  }

  .red{
    color:$pink-800;
  }
}
</style>
